import React, {ComponentType} from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {Auth} from '../setup';
import makeComp from '../util/profiler';
import {RouteWithLayout, RouteWithLayoutProps} from '../routes';

const mapStateToProps = (state: any) => ({
  hasCurrentViewer: !!state.auth.currentIdToken,
  auth: state.global.auth,
});

const authComponents: {[key: string]: ComponentType} = {};

export interface PrivateRouteProps extends RouteWithLayoutProps {
  component: ComponentType;
  auth: Auth;
  routeCache: string;
  allowAnonymous: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = makeComp(
  ({component: Component, auth, routeCache, allowAnonymous, ...rest}) => {
    let AuthComponent;
    if (routeCache) {
      // We do this to avoid remounting child components here (on initial load your component
      // will mount and unmount if you don't do this).
      AuthComponent = authComponents[routeCache];
      if (!AuthComponent) {
        AuthComponent = connect(mapStateToProps)(Component);
        authComponents[routeCache] = AuthComponent;
      }
    } else {
      AuthComponent = connect(mapStateToProps)(Component);
    }

    if (!auth.loggedIn() && !allowAnonymous) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: {from: rest.location},
          }}
        />
      );
    } else {
      return (
        <RouteWithLayout
          {...rest}
          component={auth.loggedIn() ? AuthComponent : Component}
        />
      );
    }
    /*
  return (
    <Route
      {...rest}
      render={props => {
        return auth.loggedIn() ? (
          <AuthComponent {...props} />
        ) : allowAnonymous ? (
          <Component {...props} />
        ) : (
          <Redirect to={{pathname: '/login', state: {from: props.location}}} />
        );
      }}
    />
  );
  */
  },
  {id: 'PrivateRoute'}
);

export default connect(mapStateToProps)(PrivateRoute);
